import { Tables } from '@/types';

export type InconsistencyProblem = {
  key: string;
  obs?: string;
};

export type InconsistenciesDataState = {
  active: boolean;
  problems: InconsistencyProblem[];
};

export const OBRIGATORY_EMPTY_BLOCK_REASON = 'payload vazio em tabela obrigatória (write bloqueado)';

const ATOMIC_FAILURE_TABLE_PATTERN = /salvar em ([\w]+)/;

const TABLE_DISPLAY_LABELS: Partial<Record<Tables | string, string>> = {
  marcas: 'Marcas',
  preco: 'Preço',
  estoque: 'Estoque',
  imagens: 'Imagens',
  catalogo: 'Catálogo',
  cliente: 'Clientes',
  saldo_flex: 'Saldo Flex',
  pagebuilder: 'Page Builder',
  indicadores: 'Indicadores',
  categoria: 'Categorias',
  campanha_indicador: 'Campanha indicador',
  parametros_aws: 'Parâmetros AWS',
  janela_entrega: 'Janela de entrega',
  campanha_faixa: 'Campanha faixa',
  indicador_loja: 'Indicador loja',
  dicionario_produtos: 'Dicionário de produtos',
  eventos: 'Eventos',
  campanha_cliente: 'Campanha cliente',
  campanha_produto: 'Campanha produto',
  dicionario_categorias: 'Dicionário de categorias',
  precoPromocaoCliente: 'Preço promoção cliente',
  campanha_mix_fornecedor: 'Campanha mix fornecedor',
  parametro_preco_base: 'Parâmetro preço base',
  recomendacaoBigData: 'Recomendação Big Data',
  percentual_fornecedor: 'Percentual fornecedor',
  cod_regime_tributario: 'Substituição tributária',
  ciclo_venda_cliente_cliente: 'Ciclo de venda cliente',
  restricaoProdutoCliente: 'Restrição produto cliente',
  ultima_compra: 'Última compra',
  cliente_cortes: 'Cortes do cliente',
  cliente_boletos: 'Boletos do cliente',
};

export const formatInconsistencyTableLabel = (key: string): string =>
  TABLE_DISPLAY_LABELS[key] || key.replace(/_/g, ' ');

export const parseInconsistenciesData = (value: unknown): InconsistenciesDataState | null => {
  if (value === true) return { active: true, problems: [] };
  if (!value || typeof value !== 'object') return null;

  const state = value as Partial<InconsistenciesDataState>;
  if (!state.active) return { active: false, problems: [] };

  return {
    active: true,
    problems: Array.isArray(state.problems) ? state.problems : [],
  };
};

export const formatInconsistenciesAlertMessage = (state: InconsistenciesDataState): string => {
  const suffix = 'Tente sincronizar novamente. Caso o problema persista, entre em contato com o suporte.';

  if (!state.problems.length) return suffix;

  const labels = [...new Set(state.problems.map((problem) => formatInconsistencyTableLabel(problem.key)))];
  const prefix =
    labels.length === 1
      ? `O arquivo "${labels[0]}" apresentou problemas durante a sincronização.`
      : `Os seguintes arquivos apresentaram problemas durante a sincronização: ${labels.join(', ')}.`;

  return `${prefix} ${suffix}`;
};

export const extractAtomicFailureTableKey = (message: string): string | null => {
  const match = message.match(ATOMIC_FAILURE_TABLE_PATTERN);
  return match?.[1] ?? null;
};
